import { composeClassNames } from "@faedev/editor-utils";
import Image from "next/image";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Button } from "react-bootstrap";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import constants from "src/constants";
import Small_chevron_right from "src/icons/Small-chevron-right";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sHeroBanner } from "src/styles/sHeroBanner.module.scss";
import { sHeroCalendar } from "./sHeroCalendar.module.scss";

type Props = {
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
};

function HeroGiftCard({ className, style }: Props) {
  const { locale: lang, push } = useRouter();
  return (
    <div
      className={composeClassNames([
        sHeroBanner,
        sHeroCalendar,
        className,
        "hero-banner",
        "hero-calendar",
      ])}
      style={style}
    >
      <div className="hero-banner-image-wrapper">
        <div className="hero-banner-image-inner">
          <Image
            className="hero-banner-img"
            src="/images/heroe/hero-calendar.jpg"
            alt="Calendar"
            layout="fill"
            objectFit="cover"
            priority
          />
        </div>
      </div>
      <Heading
        type="h2"
        align="left"
        className={composeClassNames([sGroupTitle, "hero-title"])}
        title="Protáhněte se do nového roku 2023 s kalendářem jógových pozic"
      />
      <div className="hero-subtitle">
        <Paragraph size="xm">
          <strong>
            48&nbsp;krásných fotografií, 4&nbsp;pozice měsíčně od lektorů
            z&nbsp;naší komunity
          </strong>
          , které zlepší vaši praxi a&nbsp;udrží vám motivaci po&nbsp;celý rok.
        </Paragraph>
      </div>
      <div className={composeClassNames([sButtons, "buttons"])}>
        <Button
          className={composeClassNames([sButton, "column", "btn-icon-after"])}
          onClick={() => push(constants.Paths.calendar)}
          size="lg"
          variant="primary"
        >
          Udělejte si radost
          <br />
          <small>Vivido kalendářem 2023</small>
          <Small_chevron_right />
        </Button>
      </div>
    </div>
  );
}

export default HeroGiftCard;
